module.exports = __webpack_public_path__ + "static/gamepad-book-square-a02870214e05602dd5d8aed24ebcd277.png";